import type { EventPlaybackClipRequest } from '../models/entities/event-playback.model';

export function buildPlaybackClipFilename(body: EventPlaybackClipRequest): string {
  const start = sanitizeClipFilenamePart(body.trimStart);
  const end = sanitizeClipFilenamePart(body.trimEnd);
  const camera = Number.isFinite(body.cameraNumericId) ? body.cameraNumericId : 'cam';
  const eventType = body.eventType?.trim() || 'clip';
  return `playback-clip-${camera}-${eventType}-${start}_${end}.mp4`;
}

export function parseContentDispositionFilename(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }

  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() || null;
}

function sanitizeClipFilenamePart(value: string): string {
  return value.replace(/[:.]/g, '-').replace(/[^A-Za-z0-9T_-]/g, '');
}
